import React from 'react';
import { Link } from 'react-router-dom';
import { GitMerge } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-slate-200 bg-white" data-id="element-136">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-137">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-138">
          <div className="space-y-8 xl:col-span-1" data-id="element-139">
            <Link to="/" className="flex items-center gap-2" data-id="element-140">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 text-white" data-id="element-141">
                <GitMerge size={20} data-id="element-142" />
              </div>
              <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-143">
                DemandPath
              </span>
            </Link>
            <p className="text-sm leading-6 text-slate-500 max-w-xs" data-id="element-144">
              Route every lead to the right rep, and automate the right next
              step in HubSpot.
            </p>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" data-id="element-145">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-146">
              <div data-id="element-147">
                <h3 className="text-sm font-semibold leading-6 text-slate-900" data-id="element-148">
                  Product
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-149">
                  <li data-id="element-150">
                    <Link to="/product" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-151">
                      Features
                    </Link>
                  </li>
                  <li data-id="element-152">
                    <Link to="/why-not-hubspot-workflows" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-153">
                      Vs. HubSpot Workflows
                    </Link>
                  </li>
                  <li data-id="element-154">
                    <Link to="/use-cases" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-155">
                      Use Cases
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-156">
                <h3 className="text-sm font-semibold leading-6 text-slate-900" data-id="element-157">
                  Use Cases
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-158">
                  <li data-id="element-159">
                    <Link to="/use-cases" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-160">
                      Territory Routing
                    </Link>
                  </li>
                  <li data-id="element-161">
                    <Link to="/use-cases" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-162">
                      Round Robin
                    </Link>
                  </li>
                  <li data-id="element-163">
                    <Link to="/use-cases" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-164">
                      SDR to AE Handoffs
                    </Link>
                  </li>
                  <li data-id="element-165">
                    <Link to="/use-cases" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-166">
                      SLA Enforcement
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-167">
              <div data-id="element-168">
                <h3 className="text-sm font-semibold leading-6 text-slate-900" data-id="element-169">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-170">
                  <li data-id="element-171">
                    <a href="#" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-172">
                      About
                    </a>
                  </li>
                  <li data-id="element-173">
                    <a href="#" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-174">
                      Blog
                    </a>
                  </li>
                  <li data-id="element-175">
                    <a href="#" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-176">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-177">
                <h3 className="text-sm font-semibold leading-6 text-slate-900" data-id="element-178">
                  Legal
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-179">
                  <li data-id="element-180">
                    <a href="#" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-181">
                      Privacy
                    </a>
                  </li>
                  <li data-id="element-182">
                    <a href="#" className="text-sm leading-6 text-slate-600 hover:text-slate-900" data-id="element-183">
                      Terms
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-slate-200 pt-8 sm:mt-20 lg:mt-24" data-id="element-184">
          <p className="text-xs leading-5 text-slate-500" data-id="element-185">
            &copy; {new Date().getFullYear()} DemandPath, Inc. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}